import { useEffect, useMemo, useState } from "react";

/**
 * Approximate diagnosis date , Year + Month only (day not needed).
 * value: "YYYY-MM" string
 */
const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

function splitYM(value) {
  if (!value) return { y: "", m: "" };
  const parts = value.split("-");
  return { y: parts[0] || "", m: parts[1] || "" };
}

export function MonthYearPicker({ value, onChange, "data-testid": testId }) {
  const initial = useMemo(() => splitYM(value), [value]);
  const [parts, setParts] = useState(initial);

  useEffect(() => {
    if (!value) return;
    const next = splitYM(value);
    if (next.y !== parts.y || next.m !== parts.m) setParts(next);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const now = new Date();
  const thisYear = now.getFullYear();
  const years = useMemo(() => {
    const arr = [];
    for (let y = thisYear; y >= thisYear - 100; y--) arr.push(String(y));
    return arr;
  }, [thisYear]);

  const update = (next) => {
    const merged = { ...parts, ...next };
    setParts(merged);
    if (merged.y && merged.m) onChange?.(`${merged.y}-${merged.m}`);
    else onChange?.("");
  };

  const selectCls =
    "h-12 px-3 rounded-xl border border-[var(--light-border)] bg-white text-[15px] text-[var(--charcoal)] transition-all focus:outline-none focus:border-[var(--lime)] focus:ring-4 focus:ring-[var(--lime)]/20 appearance-none cursor-pointer";

  return (
    <div className="grid grid-cols-2 gap-2" data-testid={testId}>
      <select
        aria-label="Month"
        className={selectCls}
        value={parts.m}
        onChange={(e) => update({ m: e.target.value })}
        data-testid={testId ? `${testId}-month` : undefined}
      >
        <option value="">Month</option>
        {MONTHS.map((label, i) => (
          <option key={label} value={String(i + 1).padStart(2, "0")}>
            {label}
          </option>
        ))}
      </select>
      <select
        aria-label="Year"
        className={selectCls}
        value={parts.y}
        onChange={(e) => update({ y: e.target.value })}
        data-testid={testId ? `${testId}-year` : undefined}
      >
        <option value="">Year</option>
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
    </div>
  );
}

export default MonthYearPicker;
